import service from './service.js';

export default {
  pagamento(data) {
    return service.execute('post', 'utente/pagamento', data);
  }
}



// WEBPACK FOOTER //
// ./src/services/pagamento.js